// extracted by mini-css-extract-plugin
module.exports = {"root":"MinNextPromptDelay_root__19PGN","input":"MinNextPromptDelay_input__2icKD","units":"MinNextPromptDelay_units__9u2ep"};